import React, { useEffect, useRef, useState } from "react";
import htmlParse from "html-react-parser";
import Button from "../../../../Foundation/Button/Button";
import {
  _LandingHeaderCtaWrapper,
  _LandingHeaderRoot,
} from "../LandingHeader.styled";
import Typography from "../../../../Foundation/Typography/Typography";
import LandingSectionBase from "../../LandingSectionBase/LandingSectionBase";
import VideoIllustration, {
  VideoIllustrationRef,
} from "./VideoIllustration/VideoIllustration";
import { _LandingHeaderMargauxMotinRoot } from "./LandingHeaderMargauxMotin.styled";
import useOnScreen from "../../../../Hooks/useOnScreen";
import DecorationBox from "../../../DecorationBox/DecorationBox";
import MargauxMotinLogo from "../../../MargauxMotinLogo/MargauxMotinLogo";
import getMobileOperatingSystem from "../../../../Utils/getMobileOperatingSystem";
import { margauxMotinImages } from "../../../../Assets/images/margaux-motin";

interface ILogoData {
  logoId?: string;
}

interface ILandingHeaderMargauxMotinProps extends ILogoData {
  image?: string;
  title?: string;
  subtitle?: string;
  description?: string;
  ctaLabel: string;
  onClick?: () => void;
  backgroundImage?: {
    desktop?: string;
    mobile?: string;
  };
  videoSrc?: string;
}

const LandingHeaderMargauxMotin = (props: ILandingHeaderMargauxMotinProps) => {
  const {
    subtitle,
    title,
    description,
    ctaLabel = "Je découvre",
    onClick,
    backgroundImage,
    videoSrc,
  } = props;
  const videoIllustrationRef = useRef<VideoIllustrationRef>(null);
  const [ref, isOnScreen] = useOnScreen<HTMLDivElement>({
    threshold: 0.1,
  });

  useEffect(() => {
    if (isOnScreen) {
      const mobileOperatingSystem = getMobileOperatingSystem();
      console.log("mobileOperatingSystem--", mobileOperatingSystem);
      // Delay play for iOS compatibility
      const callback = () => {
        if (videoIllustrationRef.current) {
          videoIllustrationRef.current.play();
        }
      };
      const timeout = mobileOperatingSystem === "iOS" ? 1800 : 300;
      setTimeout(callback, timeout); // Increased delay for iOS
    } else {
      videoIllustrationRef.current?.pause();
      videoIllustrationRef.current?.reset();
    }
  }, [isOnScreen]);

  return (
    <_LandingHeaderMargauxMotinRoot>
      <LandingSectionBase
        boxContainer={true}
        // topVariant="align-left"
        topPosition="top"
        backgroundImage={backgroundImage}
        renderImage={() => {
          return (
            <>
              <VideoIllustration
                ref={videoIllustrationRef}
                constainerRef={ref}
                videoSrc={videoSrc}
                width={675}
                height={688}
                duration={6}
                loop={false}
                autoPlay={false}
                posterImage={margauxMotinImages.landingHeaderMargauxMotin}
                className="margaux-motin-animation"
              >
                <DecorationBox
                  className="margaux-motin-animation-content-decoration"
                  imageName="heart"
                  alt="heart"
                  enableAnimation={true}
                  animationType="slideLeft"
                  animationDelay={300}
                />
              </VideoIllustration>
              <DecorationBox
                className="margaux-motin-animation-content-decoration-2 desktop-decoration"
                imageName="girlUmbrella"
                alt="girlUmbrella"
                enableAnimation={true}
                animationType="slideLeft"
                animationDelay={300}
                animationDistance={300}
              />
            </>
          );
        }}
        onImageClick={onClick}
        imageLeft={false}
        topContent={
          <span className="landing-header__head__intro js-anchor">
            <MargauxMotinLogo />
          </span>
        }
        bottomClassName="margaux-motin-bottom"
        bottomContent={
          <div className="margaux-motin-bottom-content">
            <DecorationBox
              className="margaux-motin-bottom-content-decoration desktop-decoration"
              imageName="bird"
              alt="bird"
              enableAnimation={true}
              animationType="slideDown"
              animationDelay={300}
            />
            {title && (
              <Typography variant="h4" className="landing-header__title title">
                {title}
              </Typography>
            )}
            <Typography
              variant="margaux1"
              color="margauxPink"
              className="landing-header__intro"
              mb={16}
            >
              {subtitle}
            </Typography>
            <Typography variant="subtitle2" className="landing-header__intro">
              {htmlParse(description + "")}
            </Typography>
            <_LandingHeaderCtaWrapper className="landing-header__head__cta">
              <Button onClick={onClick}>{ctaLabel}</Button>
            </_LandingHeaderCtaWrapper>

            <DecorationBox
              className="margaux-motin-bottom-content-decoration-2 desktop-decoration"
              imageName="dadAndKids"
              alt="dadAndKids"
              enableAnimation={true}
              animationType="slideUp"
              animationDelay={300}
            />
          </div>
        }
      />
    </_LandingHeaderMargauxMotinRoot>
  );
};

export default LandingHeaderMargauxMotin;
